import React, { useState, useEffect } from 'react';
import Field from '../../Components/Field/Field';
import SpaceInvader from '../../Components/SVG/SpaceInvader'
import KaleidoscopeAPI from '../../Core/KaleidoscopeAPI';
import CTAButton from '../../Components/CTAButton/CTAButton';
import { MAIN_CONFIG, dataTypeDoc, dataTypeJoin } from '../../../config/main';
import './form.scss';
import { CreateOptions } from '../../Utility/SelectListLoader';
import { getQuestionDataType } from '../../Utility/RecommendationDataTypeMapping';
import { parseHtml, formatAnswerOptions, renderQuestionLabelWithAsterisk } from '../../Utility/HelperFunctions';
import { getAnswer, getDocumentObject, applicantValidation, onChangeAnswer, findLabel, skipConfigIds, skipConfigValue, updateFormulaFieldAnswer, allowApplicantUploadsAfterDeadlineFunction, handleKeyDown, getPlaceholder } from '../../Utility/ApplicationFormUtility';
import FlashMessage from '../../Components/FlashMessage/Message';
import { toast } from 'react-toastify';
import { cloneDeep, isEmpty, uniq } from 'lodash';
import SweetAlert from 'react-bootstrap-sweetalert';
import cookies from 'next-cookies';
import Close from '../SVG/Close';



export default ({
  handleClose = () => { },
  handleSubmit = () => { },
  filterFieldData = [],
  questions = [],
  dependentConfigsForVariousSteps = [],
  dependentConfigs = [],
  editTaskData = {},
  staticObj = {},
  herokuRole = '',
  type = '',
  applicationDependentConfigs = [],
  allowApplicantUploadsAfterDeadline = false,
  onSuggestiveSelect = () => { },
  setFieldData = () => { },
  applicationData = [],
  setIsOpenSweetAlert = ()=> {},
  isOpenSweetAlert = false,
  alretMsg,
  applicationId
}) => {
  const API = new KaleidoscopeAPI({});
  const [questionData, setQuestionData] = useState(questions);
  // const [isOpenSweetAlert, setIsOpenSweetAlert] = useState(false)

  const userContext = cookies('context').context

  let arr = JSON.parse(localStorage.getItem('hasAccessCode')) || []



  /**
   * Handle modal field value change.
   */
  const filterConfigFields = (data, dependentConfigsForVariousSteps) => {
    let skipConfigIdField = skipConfigIds(data, filterFieldData.concat(dependentConfigsForVariousSteps || []) || [])
    let skipConfigValueField = skipConfigValue(skipConfigIdField, filterFieldData.concat(dependentConfigsForVariousSteps || []) || [])
    skipConfigValueField.filter(question => {
      question.answer = (['Date(Date-Month-Year)', 'Date', 'Date(Month-Date-Year)'].includes(question.data_type__c)) ? (question.answer || question.default_day_for_date__c) : question.answer || ''
    })

    return skipConfigValueField
  }

  const [questionFilterData, setQuestionFilterData] = useState(filterConfigFields(questions, dependentConfigsForVariousSteps));

  const [errors, setErrors] = useState([]);


  const onQuestionSuggestiveSelect = (name, selectedValue = {}) => {
    let newState = [...questions]
    let input = newState.find((input) => {
      return input.name === name
    })
    input.answer = selectedValue.name ? selectedValue.name : selectedValue
    newState.map(record => {
      if (record.address_auto_fill_type__c && selectedValue[record.address_auto_fill_type__c]) {
        record.answer = selectedValue[record.address_auto_fill_type__c]
      }
    })
    setFieldData(newState)
    filterConfigFields(newState, applicationData.dependent_configs_for_various_steps)
    var temp = errors.filter(obj => obj.id != input.id)
    setErrors([...temp])
  }

  /**
   * Handle Application answer value changes
   */
  const onChange = (name, value, deleteDocument = false, videoDuration = '') => {
 // const isDocument = !!value.event
    const isDocument = value?._response?.status===201
    const videodurationInSeconds = videoDuration || value?._response?.video_duration__c || ''
    const newState = [...questionData];
    let index = newState.findIndex(item => item.id === name);
    let question = newState.find(record => record.id === name)
    question = onChangeAnswer(question, value, isDocument, deleteDocument, videodurationInSeconds)
    let childPicklist = newState.find(obj => obj.parent_picklist_config__c === question.sfid.toString())

    if (childPicklist) {
      childPicklist.answer = '';
    }
    newState[index] = question

    let dependentChild = (question.skip_config_ids__c) ? question.skip_config_ids__c.split(';') : [question.skip_config_ids__c]

    newState.filter(childAnswerReset => {
      if (dependentChild.includes(childAnswerReset.name)) {
        childAnswerReset.answer = ''
      }
    })

    updateFormulaFieldAnswer(newState, dependentConfigs)
    setQuestionData(newState)
    setQuestionFilterData(filterConfigFields(newState, dependentConfigsForVariousSteps))

    if (errors.length > 0) {
      var temp = errors.filter(obj => obj.id != question.id)

      // let valid = applicantValidation([question], dependentConfigsForVariousSteps, applicationDependentConfigs);
      // setErrors([...temp])

      var temp = errors.filter(obj => obj.id != question.id)
      if ((question.data_type__c === 'Long Text') && question.word_count_enable__c) {
        const minWords = question.minimum_word_required__c || 0
        var words;
        words = ((question.answer || "").match(/\S+/g) || []).length || 0;
        if (words < minWords) {
          // errors[question.name] = `Please enter minimum ${minWords} words.`
          applicantValidation([question], dependentConfigsForVariousSteps, applicationDependentConfigs);

        } else {
          var tempErr = errors.filter(obj => obj.id != question.id)
          setErrors([...tempErr])
        }
        applicantValidation([question], dependentConfigsForVariousSteps, applicationDependentConfigs);
      }
      // else if (question.data_type__c === 'Number' && question.required__c && (question.number_input_required_max_length__c || question.number_input_required_min_length__c || question.max_value__c || question.min_value__c)) {
      //   // applicantValidation([question], dependentConfigsForVariousSteps, applicationDependentConfigs);
      // }
      else {
        applicantValidation([question], dependentConfigsForVariousSteps, applicationDependentConfigs);
        setErrors([...temp])
      }
    }
  }

  /**
   * Handle task form submission.
   */
  const submitTask = (e) => {
    e.preventDefault();
    let valid = false
    valid = applicantValidation(questionFilterData, dependentConfigsForVariousSteps, applicationDependentConfigs, "isShowMessage");
    setErrors(valid != 'true' ? valid : [])
    if (valid == 'true') {
      handleSubmit(questionFilterData, type)
    }
  }

  const handleShowError = (id) => {
    var message = ""
    if (errors.length > 0) {
      errors.map((item) => {
        if (id === item.id) {
          message = item.message
        }
      })
      return message
    }
    return null
  }

  const MultiLevelPiclistData = (fieldObj, answer) => {
    const picklistDep = (fieldObj.answer_options__c || '').split(/\r?\n/)
    let answerObj = {}
    picklistDep.map(val => {
      let values = val.split(';')
      const key = values.splice(0, 1)
      values = values.filter(val => !isEmpty(val))
      answerObj[key[0]] = values
      return null
    })

    let configVal = {
      title: answer ? answer : (fieldObj.answer ? fieldObj.answer : 'Choose your answer.')
    };

    const getSubMenu = (title) => {
      return {
        'title': title,
        'subMenu': null
      }
    }

    const configSubMenus = Object.keys(answerObj).map((key, index) => {
      const subMenus = answerObj[key].map(k => {
        return getSubMenu(k)
      })
      return {
        'title': key,
        'submenu': subMenus
      }
    })

    configVal['submenu'] = configSubMenus

    return [configVal]
  }
  // Answer dependent picklist
  const answerDependentOptions = (fieldObj, question) => {
    const parentVals = question.parent_picklist__c.split(';');
    const parentObj = questions.filter(obj => { return parentVals.includes(obj.name.toString()) })
    let answersToRemove = []
    parentObj.map(parent => {
      if (parent.answer) {
        const parentAns = parent.answer
        if (parent.data_type__c === "Multiselect Picklist") {
          const ansVal = Array.isArray(parentAns) ? parentAns : parentAns.split(';')
          ansVal.map(a => answersToRemove.push(a))
        } else {
          answersToRemove.push(parentAns)
        }
      }
      return null
    })


    const fieldOptions = (question.answer_options__c.split(';'))
    let finalOptions = []
    if (fieldOptions.length > 0) {
      fieldOptions.map(opt => {
        if (answersToRemove.indexOf(opt) < 0) {
          finalOptions.push(opt)
        }
        return null
      })
    }
    if ((question.answer) && (finalOptions.indexOf((question.answer)) < 0)) {
      onChange(question.id, "")
    }

    return formatAnswerOptions(finalOptions.join(";"))
  }

  // dependent picklist
  const dependentPicklistOptions = (question) => {
    const parentObj = questions.find(obj => { return obj.sfid.toString() === question.parent_picklist_config__c })
    if (parentObj) {
      const parentAns = (parentObj.answer)
      const picklistDep = question.picklist_dependency__c.split(/\r?\n/)
      let anserOptions = "";
      let options = [];
      if (parentObj.data_type__c === "Multiselect Picklist") {
        const ansVal = Array.isArray(parentAns) ? parentAns : (parentAns || '').split(';')
        let multipleOptions = [];
        ansVal.map((val) => {
          anserOptions = questions.find(obj => { return obj.sfid.toString() === question.parent_picklist_config__c })
          picklistDep.find(obj => { return obj.split(';')[0] === val }) || ''
          multipleOptions = multipleOptions.concat(anserOptions.split(';'))
          multipleOptions = multipleOptions.filter(function (el) {
            return !(el === val)
          });
          return null
        })
        options = uniq(multipleOptions);
      } else {
        anserOptions = picklistDep.find(obj => { return obj.split(';')[0] === parentAns }) || ''
        let optionsingle = anserOptions.split(';')

        let count = 0
        optionsingle.map(function (el) {
          if (el === parentAns) {
            count = count + 1
          }
        });
        if (count > 1) {
          options = uniq(optionsingle);
        } else {
          options = optionsingle.filter(function (el) {
            return !(el === parentAns)
          });
        }
      }
      options = options.filter(function (el) {
        return !isEmpty(el)
      });
      return formatAnswerOptions(options.join(";"))
    } else {
      return []
    }
  }
  const optionMultiSelect = (question) => {
    const parentObj = questions.find(obj => { return obj.sfid.toString() === question.parent_picklist_config__c })
    if (parentObj) {
      const parentAns = (parentObj.answer)
      const picklistDep = question.picklist_dependency__c.split(/\r?\n/)
      let anserOptions = "";
      let options = [];
      if (parentObj.data_type__c === "Multiselect Picklist") {
        const ansVal = Array.isArray(parentAns) ? parentAns : (parentAns || '').split(';')
        var multipleOptions = [];
        let dependOption = [];
        ansVal.map((val) => {
          anserOptions = picklistDep.find(obj => { return obj.split(';')[0] === val }) || ''
          let multipleOption = multipleOptions.concat(anserOptions.split(';'))
          // multipleOptions = multipleOptions.filter(function (el) {
          //   return !(el === val)
          // });
          let count = 0
          multipleOption.map(function (el) {
            if (el === val) {
              count = count + 1
            }
          });
          if (count > 1) {
            multipleOption = uniq(multipleOption)
          } else {
            multipleOption = multipleOption.filter(function (el) {
              return (el !== val)
            });
          }
          multipleOptions.push(...multipleOption)
          return null
        })
        let newMultipleOption = []
        newMultipleOption = uniq(multipleOptions)
        options = newMultipleOption.filter(function (el) {
          return !isEmpty(el)
        });
        return formatAnswerOptions(options.join(";"))
      }
    } else {
      return []
    }
  }

  const handleMultiSelectDependentPicklist = (question) => {
    const dataAry = question.dependent_answer_options__c ? optionMultiSelect(question) : question.answer_options__c.split(';')
    return dataAry;
  }

  /**
   * Render Application Question Input
   * @returns {JSX.Element}
   */
  const renderApplicationInput = () => questionFilterData.map((question) => {
    return (
      <div className="application-section__question" key={question.sfid}>
        <Field
          id={question.id}
          label={renderQuestionLabelWithAsterisk(question)}
          ariaLabel={question.label__c}
          labelClassName="application-field-label-style"
          className="application-section__textarea"
          max_video_length_in_seconds__c={question.max_video_length_in_seconds__c}
          min_video_length_in_seconds__c={question.min_video_length_in_seconds__c}
          minNumber={question.exit_config__c ? '' : question.min_value__c}
          maxNumber={question.exit_config__c ? '' : question.max_value__c}
          minDateFilter={question.exit_config__c ? '' : question.min_date__c}
          maxDateFilter={question.exit_config__c ? '' : question.max_date__c}
          description={parseHtml(question.description__c)}
          dateFormat={question.data_type__c}
          multiLevelQeustion={question}
          maxLengthInput={question.number_input_required_max_length__c ? question.number_input_required_max_length__c : null }
          multiLevelPiclistData={() => MultiLevelPiclistData(question, question.answer)}
          options={question.data_type__c === "Answer Dependent Picklist" ? answerDependentOptions(question.answer_options__c || '', question) : question.data_type__c === "Dependent Picklist" ? dependentPicklistOptions(question) : question.dependent_answer_options__c ? handleMultiSelectDependentPicklist(question) : formatAnswerOptions(question.answer_options__c || '', question.data_type__c)}
          // options={question.data_type__c === "Answer Dependent Picklist" ? answerDependentOptions(question.answer_options__c || '', question) : question.data_type__c === "Dependent Picklist" ? dependentPicklistOptions(question) : formatAnswerOptions(question.answer_options__c || '', question.data_type__c)}
          // errorMsg={errors.includes(question.id) && (question.error_message__c || MAIN_CONFIG.DEFAULT_ERROR)}
          errorMsg={handleShowError(question.id)}
          placeholder={getPlaceholder(question.data_type__c)}
          type={getQuestionDataType(question.data_type__c)}
          value={getAnswer(question)}
          required={question.is_required__c || question.minimum_word_required__c && question.word_count_enable__c}
          uploadedDocument={getDocumentObject(question)}
          has_document={question.doc_upload_required__c}
          handleChange={(value, videoDuration) => onChange(question.id, value, videoDuration)}
          removeCrossIcon={(type === 'edit') ? true : false}
          handleDocumentDelete={(documentName) => deleteAzureDocument(documentName)}
          videoLable={findLabel(question)}
          minWordCountLongText={question.minimum_word_required__c ? question.minimum_word_required__c : question.word_count_enable__c ? true : false}
          // charLimit={question.word_count_enable__c && question.data_type__c === 'Long Text' ? question.word_count__c : question.word_count__c || 2500}
          charLimit={question.data_type__c === 'Long Text' ? question.word_count_enable__c ? question.word_count__c ? question.word_count__c : 25000 : 25000 : 255}
          disabled={arr.includes(applicationId) ? false : allowApplicantUploadsAfterDeadline ? allowApplicantUploadsAfterDeadlineFunction(getQuestionDataType(question.data_type__c)) : question.read_only__c}
          allowApplicantUploadsAfterDeadline={allowApplicantUploadsAfterDeadline && question.doc_upload_required__c || false}
          suggestionData={question}
          autoSuggest={question.data_type__c !== "Picklist" && question.auto_suggest__c}
          onSuggestiveSelect={onSuggestiveSelect}
          onQuestionSuggestiveSelect={onQuestionSuggestiveSelect}
          allQuestionsData={questions}
					onHandleBlur={(value) => onChange(question.id, value)}
					allowHtmlTags={["Long Text", "Text"].includes(question.data_type__c)}
					isAzureDelete={true}
        />
      </div>
    )
  })

  /**
   * Delete Application Question Document
   * @returns {JSX.Element}
   */
  const updateQuestionData = async (docName) => {
    const cloneData = cloneDeep(questionData)
    const updatedData = cloneData.find((fieldData) => {
      const data = fieldData?.document?.doc_url__c
      const uploadedFileName = data?.split("/")[6];
      const fileName = uploadedFileName?.split("?").shift();
      return fileName === docName
    }
    )
   await  onChange(updatedData.id,'',true)
  }
  const deleteAzureDocument = async (documentName) => {
    let uploadedFileName = documentName?.split("/")[6];
    let fileName = uploadedFileName?.split("?").shift();
    const deleteResponse = await API.deleteAzureDocument(fileName);
    if (deleteResponse?._response?.status === 202) {
      updateQuestionData(fileName);
      toast.success(<FlashMessage message='File removed' />);
    } else {
      toast.error(<FlashMessage type="error" message='Something went wrong, please try again.' />);
    }
  };
  const handleModalClose=()=>{
    if(userContext === MAIN_CONFIG.USER_CONTEXT.APPLICANT){
      alretMsg()
    }
    else{
      handleClose()
    }
  }
  return (
    <div id='task-modal-content' className='iteration-modal-box'>
      {isOpenSweetAlert}
      <div className="task-head_container">
        <h1 className='H1DesktopGreen event-head head-text'>{applicationData.iteration_label__c ? applicationData.iteration_label__c : applicationData.title__c  }</h1>
        <button onKeyDown={(e)=>handleKeyDown(e,()=>handleModalClose())} aria-label='Close Modal' className="event-head cancel-icon H6DesktopGrey" onClick={handleModalClose}><Close color={MAIN_CONFIG.COLORS.fillGreen} ariaLabel="Close Modal Button" ariaLabelDescription='' tabIndex={-1}/></button>
      </div>

      <div className="user-task-add__form">
        <form>
          {
            renderApplicationInput()
          }
          <div className="applicant-task__submit">
            <CTAButton id='task-page__cta__cancel' type='inverse' outline onClick={handleClose}>
              Cancel
            </CTAButton>

            <CTAButton id='task-page__cta' type='tertiary' onClick={(e) => submitTask(e)}>
              Submit
            </CTAButton>
          </div>

        </form>
      </div>
    </div>
  )
}
